module.exports = "/_next/static/images/Frame@2x-d8d23f2089da55a063f1fcd865d040b3.webp";